import { Directive, HostListener, EventEmitter, Output, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { HeightValidatorService } from '../services/height-validator.service';
import { DeckHeightService } from '../services/deck-height.service';
import { ToasterService } from 'angular2-toaster';

@Directive({
  selector: '[appInputHeightValidator]',
})
export class InputHeightValidatorDirective {

  public lastValidFeetValue: number = 0;
  private el: any;
  @Output() ngModelChange = new EventEmitter();

  constructor(
    public ngControl: NgControl,
    private heightValidatorService: HeightValidatorService,
    private elementRef: ElementRef,
    private deckHeightService: DeckHeightService,
    private toasterService: ToasterService
  ) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(value) {
    this.changeFeetValidator(this.el.value);
  }

  @HostListener('blur', ['$event'])
  focusOut(value) {
    this.lastValidFeetValue = Math.floor(this.deckHeightService.getDeckHeight() / 12);
    if (this.changeFeetValidator(this.el.value)) {
      this.ngModelChange.emit(this.el.value);
    }
    else {
      this.el.value = this.lastValidFeetValue;
      this.ngModelChange.emit(this.el.value);
      this.showToast('warning', 'Invalid value', "Minimal height exceeded");
    }
  }
  @HostListener('keydown.enter', ['$event'])
  keydownEnter(value) {
    this.lastValidFeetValue = Math.floor(this.deckHeightService.getDeckHeight() / 12);
    if (this.changeFeetValidator(this.el.value)) {
      this.ngModelChange.emit(this.el.value);
    }
    else {
      this.el.value = this.lastValidFeetValue;
      this.ngModelChange.emit(this.el.value);
      this.showToast('warning', 'Invalid value', "Minimal height exceeded");
    }
  }

  onInputChange(value, backspace) {
    if (this.changeFeetValidator(value)) {
      this.el.value = value;
      this.ngModelChange.emit(this.el.value);
    }
    else {
      this.el.value = value;
      this.ngModelChange.emit(this.el.value);
    }
  }

  changeFeetValidator(value): boolean {
    let minHeight = Math.floor(this.heightValidatorService.getMinHeight() * 0.0328084);
    if (minHeight <= value) {
      this.lastValidFeetValue = value;
      return true;
    }
    else {
      return false;
    }
  }
  showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }
} 


// WEBPACK FOOTER //
// ./src/app/directives/input-height-validator.directive.ts